(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Desktop
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('header-sticky-wrapper');
      this.headerBounds = {};
      this.headerTop = 52;
      this.headerBottom = 52;

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.megaMenu = this.querySelector('.secondary-nav');
      this.mainContentTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.refreshMainContentThreshold.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      /** Desktop nav breakpoint (matches .hide-lg / mobile drawer). */
      this._desktopNavMediaQuery = window.matchMedia('(min-width: 990px)');

      this.refreshMainContentThreshold();
      this.homepageMorphLogo = document.querySelector('[data-homepage-logo-morph]');
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler, false);

      this.initHeaderAnimation();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler, false);
      window.removeEventListener('resize', this.onResizeHandler, false);
    }

    refreshMainContentThreshold() {
      const main = document.getElementById('MainContent');
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      if (main) {
        this.mainContentTop = main.getBoundingClientRect().top + scrollY;
      } else {
        const wrap = document.querySelector('.main-content-wrapper');
        this.mainContentTop = wrap ? wrap.getBoundingClientRect().top + scrollY : 0;
      }
      this.refreshHomepageScrollHideExtra();
    }

    /**
     * Extra scroll before auto-hide header (homepage + desktop nav only).
     * Omit on mobile so scroll-hide matches other pages while the drawer is in use.
     */
    refreshHomepageScrollHideExtra() {
      const isHome = document.body.classList.contains('template-index');
      this.homepageScrollHideExtra =
        isHome && this._desktopNavMediaQuery && this._desktopNavMediaQuery.matches ? 80 : 0;
    }

    onScroll() {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHideThreshold = this.mainContentTop + this.homepageScrollHideExtra;

      // NOTE:
      // scrolltop is how far down document we've scrolled (the updated/current position on the page)
      // this.currentScrollTop is the previous position on the page
      // this.mainContentTop = is how far the main content wrapper is from the top of page. This measures header scroll area.

      /* If scrolling down the page */
      if (scrollTop > this.currentScrollTop && scrollTop > scrollHideThreshold) {
        requestAnimationFrame(this.hide.bind(this));
      } /* If scrolling up the page */ else if (scrollTop < this.currentScrollTop && scrollTop > scrollHideThreshold) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          // NOTE: this.preventReveal is currently always false
        }
      }
      this.currentScrollTop = scrollTop;
    }

    initHeaderAnimation() {
      if (!this.header || !this.header.classList.contains('shopify-section-header-hidden')) {
        return;
      }
      setTimeout(
        function () {
          if (this.header.classList.contains('shopify-section-header-hidden')) {
            this.header.classList.remove('shopify-section-header-hidden');
            sessionStorage.setItem('headerAnimated', 'true');
          }
        }.bind(this),
        60
      );
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.homepageMorphLogo) {
        this.homepageMorphLogo.classList.add('homepage-logo--header-scroll-hidden');
      }
      this.closeMenuDisclosure();
      this.closeMegaMenu();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (this.header.classList.contains('shopify-section-header-hidden')) {
        this.header.classList.remove('shopify-section-header-hidden');
      }
      if (this.homepageMorphLogo) {
        this.homepageMorphLogo.classList.remove('homepage-logo--header-scroll-hidden');
      }
    }

    reset() {
      if (this.header.classList.contains('shopify-section-header-hidden')) {
        this.header.classList.remove('shopify-section-header-hidden');
      }
      if (this.header.classList.contains('shopify-section-header-sticky')) {
        this.header.classList.remove('shopify-section-header-sticky');
      }
      if (this.header.classList.contains('animate')) {
        this.header.classList.remove('animate');
      }
      if (this.homepageMorphLogo) {
        this.homepageMorphLogo.classList.remove('homepage-logo--header-scroll-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeMegaMenu() {
      if (!this.megaMenu) return;
      if (this.megaMenu.classList.contains('secondary-nav--visible')) {
        this.megaMenu.classList.remove('secondary-nav--visible');
        this.megaMenu.classList.add('secondary-nav--hidden');
      }
      if (this.megaMenu.previousElementSibling) {
        const menuButton = this.megaMenu.previousElementSibling;
        menuButton.blur();
        menuButton.ariaExpanded = false;
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /** Non-index: desktop logo sits before the header section; sync its absolute `top` to the menu row height. */
  (function syncEmbeddedDesktopLogoTop() {
    const mq = window.matchMedia('(min-width: 990px)');
    let rowObserver = null;

    function sync() {
      const wrapper = document.getElementById('header-sticky-wrapper');
      if (!wrapper || !wrapper.classList.contains('header-sticky-wrapper--desktop-logo-embedded')) {
        return;
      }
      if (!mq.matches) {
        wrapper.style.removeProperty('--header-desktop-logo-top');
        return;
      }
      const logo = wrapper.querySelector('a.header__logo--desktop:not(.homepage-desktop-logo-morph)');
      const row = wrapper.querySelector('.header__main-content');
      if (!logo || !row) {
        return;
      }
      const wRect = wrapper.getBoundingClientRect();
      const rRect = row.getBoundingClientRect();
      const topPx = rRect.top - wRect.top + (rRect.height - logo.offsetHeight) / 2;
      wrapper.style.setProperty('--header-desktop-logo-top', `${Math.max(0, topPx)}px`);
    }

    function setupRowObserver() {
      const wrapper = document.getElementById('header-sticky-wrapper');
      if (!wrapper || !wrapper.classList.contains('header-sticky-wrapper--desktop-logo-embedded')) {
        return;
      }
      const row = wrapper.querySelector('.header__main-content');
      if (!row || typeof ResizeObserver === 'undefined') {
        return;
      }
      if (rowObserver) {
        rowObserver.disconnect();
      }
      rowObserver = new ResizeObserver(() => sync());
      rowObserver.observe(row);
    }

    function init() {
      sync();
      setupRowObserver();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('resize', sync);
    mq.addEventListener('change', () => {
      sync();
      setupRowObserver();
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync).catch(() => {});
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
